"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.endZendeskSession = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactZendesk = _interopRequireWildcard(require("react-zendesk"));

var _launcher = _interopRequireDefault(require("./launcher"));

var _settings = _interopRequireDefault(require("./settings"));

var _style = require("./style");

var _utils = require("./utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/**
 * Zendesk Web Widget
 * @param {string} zendeskKey
 * @param {string} zendeskSecret
 * @param {boolean} isPositionOverlap if web view and this is true, launcher will overlap to the component below it
 * @param {boolean} isMobile if zendesk will be loaded from a web view in a mobile app
 * @param {string} accessToken
 */


var Zendesk = function Zendesk(_ref) {
  var zendeskKey = _ref.zendeskKey,
      zendeskSecret = _ref.zendeskSecret,
      isPositionOverlap = _ref.isPositionOverlap,
      isMobile = _ref.isMobile,
      accessToken = _ref.accessToken;
  var zendeskSettings = _settings["default"];
  var authResult = (0, _utils.authenticateZendesk)({
    zendeskSecret: zendeskSecret,
    passedAccessToken: accessToken
  }); // will get name, email, token if authenticated; false if not

  var _useState = (0, _react.useState)("hide"),
      widgetState = _useState[0],
      setWidgetState = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      hasZendeskLoaded = _useState2[0],
      setZendeskStatus = _useState2[1]; // TODO: Follow up zendesk with authentication issue
  // if (authResult) {
  //   // pass zendesk token
  //   zendeskSettings.authenticate = {
  //     chat: {
  //       jwtFn: function(callback) {
  //         callback(authResult.token);
  //       }
  //     }
  //   }
  // }


  (0, _react.useEffect)(function () {
    if (hasZendeskLoaded) {
      (0, _reactZendesk.ZendeskAPI)("webWidget", widgetState);
      (0, _reactZendesk.ZendeskAPI)("webWidget", "open");
    }
  }, [widgetState, hasZendeskLoaded]);

  var handleToggleWidgetState = function handleToggleWidgetState() {
    return (0, _utils.toggleWidgetState)({
      widgetState: widgetState,
      setWidgetState: setWidgetState
    });
  };

  var handleWidgetLoaded = function handleWidgetLoaded() {
    (0, _reactZendesk.ZendeskAPI)("webWidget", "open");
    (0, _reactZendesk.ZendeskAPI)("webWidget", isMobile ? "show" : "hide"); // on close/hide event

    (0, _reactZendesk.ZendeskAPI)("webWidget:on", "close", function () {
      setWidgetState("hide");
    });
    (0, _reactZendesk.ZendeskAPI)("webWidget:on", "open", function () {
      if (isMobile) {
        (0, _utils.overrideZendeskViewport)();
        (0, _utils.overrideZendeskStyle)();
      }
    });

    if (authResult) {
      (0, _reactZendesk.ZendeskAPI)("webWidget", "prefill", {
        name: {
          value: authResult.name,
          readOnly: true
        },
        email: {
          value: authResult.email
        }
      });
    } // set zendesk has already loaded


    setZendeskStatus(true);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactZendesk["default"], _extends({
    zendeskKey: zendeskKey
  }, zendeskSettings, {
    onLoaded: handleWidgetLoaded
  })), !isMobile && hasZendeskLoaded && /*#__PURE__*/_react["default"].createElement(_style.LauncherContainer, {
    isPositionOverlap: isPositionOverlap
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_launcher["default"], {
    toggleWidgetState: handleToggleWidgetState
  }))), isMobile && /*#__PURE__*/_react["default"].createElement(_style.LoaderContainer, null, /*#__PURE__*/_react["default"].createElement(_style.Loader, null)));
};

Zendesk.propTypes = process.env.NODE_ENV !== "production" ? {
  zendeskKey: _propTypes["default"].string.isRequired,
  zendeskSecret: _propTypes["default"].string.isRequired,
  isPositionOverlap: _propTypes["default"].bool,
  isMobile: _propTypes["default"].bool,
  accessToken: _propTypes["default"].string
} : {};
Zendesk.defaultProps = {
  isPositionOverlap: false,
  isMobile: false,
  userInfo: {},
  accessToken: undefined
};

var endZendeskSession = function endZendeskSession() {
  return (0, _reactZendesk.ZendeskAPI)("webWidget", "logout");
};

exports.endZendeskSession = endZendeskSession;
var _default = Zendesk;
exports["default"] = _default;